import { Spinner as PolarisSpinner, SpinnerProps } from '@shopify/polaris';
import styled from 'styled-components';
import React from 'react';
import { theme } from '../../data/themes/theme';

const StyledSpinner = styled.div`
    display: inline;

    .Polaris-Spinner {
        margin-top: 0;

        // svg {
        //     fill: ${(props) => props.color || theme.colors.accent};
        // }
    }
`;

type LoadingSpinnerProps = {
    color?: string;
    spinnerProps?: SpinnerProps;
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = (props) => {
    return (
        <StyledSpinner color={props.color}>
            <PolarisSpinner {...props.spinnerProps} />
        </StyledSpinner>
    );
};
